import { render, staticRenderFns } from "./AddRecruiter.vue?vue&type=template&id=6248631c&"
import script from "./AddRecruiter.vue?vue&type=script&lang=js&"
export * from "./AddRecruiter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports